// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"443":"vote","719":"unsubscribe"}[chunkId] + "." + {"443":"d6cc869b","719":"a1950f08"}[chunkId] + ".css";
};